module.exports = __webpack_public_path__ + "static/img/5.8e1b4208.jpg";